import React from 'react'
import { reduxForm } from 'redux-form'
import InquireFormFields from 'forms/public/inquire/fields'
import RequestTourHandler from 'components/shared/modals/handlers/request-tour'
import PropTypes from 'prop-types'

const InquireForm = ({ handleSubmit, submitButtonTitle, className, form, handleClick, city }) => {
  return (
    <form onSubmit={handleSubmit} className={className}>
      <InquireFormFields form={form} />
      <RequestTourHandler
        city={city}
        submitButtonTitle={submitButtonTitle}
        handleClick={handleClick}
      />
    </form>
  )
}

InquireForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitButtonTitle: PropTypes.string,
  form: PropTypes.string,
  handleClick: PropTypes.func,
  initialValues: PropTypes.object,
  city: PropTypes.string,
}

export default reduxForm({})(InquireForm)
